import { OrderListTestIds } from '../../../../../utils/testIds/OrderList.testIds';
import { ActionEnum } from '../../../actions/types/orderActions.types';
import { StatusType } from '../../../order.types';
import { ChangeOrderStatusModalAcceptedStatus } from '../changeOrderStatusModal.types';

export const getStatusToChangeOrderStatusModalBasedInAction = (
  action?: ActionEnum,
): ChangeOrderStatusModalAcceptedStatus | undefined => {
  switch (action) {
    case ActionEnum.MOVE_TO_CANCELED:
      return StatusType.CANCELED;
    case ActionEnum.MOVE_TO_REJECTED:
      return StatusType.REJECTED;
    default:
      return undefined;
  }
};

export const getChangeOrderStatusModalConfirmButtonTestId = (status: StatusType): string => {
  const testIdMap: Partial<Record<StatusType, string>> = {
    [StatusType.CANCELED]: OrderListTestIds.CANCEL_CONFIRM_BUTTON,
    [StatusType.APPROVED]: OrderListTestIds.APPROVE_CONFIRM_BUTTON,
  };
  return testIdMap[status] || OrderListTestIds.DEFAULT_CONFIRM_MODAL_BUTTON;
};
